import { useQuery } from 'react-query'
import { getGroupAllPayments } from 'services/easyPay'
import { PAYABLES_QUERY_KEY } from './usePayables'

/**
 * How to pay a given fund by hand, for screens that only know its id.
 *
 * `manual_payment` rides on the payables payload rather than on a lookup of
 * its own, so this reuses the `['get-all-payment']` cache the landing path has
 * usually already filled. Disabled by default: it is only ever needed on the
 * branch where no gateway can take the payment, and that branch is rare enough
 * that firing a request for it on every receipt would be pure waste.
 */
export default function useBoxManualPayment(
    boxId?: number,
    enabled: boolean = false
) {
    const { data, isFetched } = useQuery(
        PAYABLES_QUERY_KEY,
        getGroupAllPayments,
        {
            enabled: enabled && !!boxId,
            staleTime: 60_000,
        }
    )

    return {
        info: data?.find(
            (item) => item.box_id === boxId && item.manual_payment?.phone
        )?.manual_payment,
        /**
         * Whether `info` is an answer or just "not yet". Undefined means both,
         * and a caller that reports "this fund has no manual details" while the
         * request is still in flight reports it wrong for every fund.
         */
        isSettled: !enabled || isFetched,
    }
}
